module.exports = __webpack_public_path__ + "static/media/Hairstyle.d07ea398.png";